module.exports = __webpack_public_path__ + "static/media/footer_img2.b5accc2a.svg";